import {formatCurrencyValue} from "../../util/PaymentUtils";

export interface PayoutTransaction {
  transactionNumber: string;
  /** Supplier amount for charge rows, in cents. 0 for refund rows. */
  payoutAmount: number;
  /** Supplier amount for refund rows, in cents. 0 or missing for charge rows. */
  refundAmount?: number;
  /** Human-readable transaction type label from the API, e.g. "Booking Charge", "Billing Correction Refund". */
  chargeType: string;
  serviceDates: string;
  paymentDate: string;
  buyerCompanyName: string;
  locationName: string;
  orderNumber: string;
  paymentType: string;
}

export const isRefundRow = (transaction: PayoutTransaction): boolean => (transaction.refundAmount ?? 0) > 0;

/** Refund rows render as a deduction ("-$123.45"); charge rows as the payout amount. */
export const formatRowAmount = (transaction: PayoutTransaction): string =>
  isRefundRow(transaction)
    ? `-${formatCurrencyValue(transaction.refundAmount as number, true)}`
    : `${formatCurrencyValue(transaction.payoutAmount, true)}`;
